const ufeApi = require('services/api/ufeApi');
const basketUtils = require('utils/Basket');

// https://jira.sephora.com/wiki/display/ILLUMINATE/Apply+Promotion+API

function applyPromotion(couponCode, captchaToken) {
    const Location = require('utils/Location.js');
    const queryParams = [];
    const params = { couponCode };

    let url = '/api/shopping-cart/basket/promotions';

    if (Location.isCheckout()) {
        queryParams.push('is_from_checkout=true');
    }

    if (queryParams.length) {
        url += '?' + queryParams.join('&');
    }

    if (captchaToken) {
        params.captchaToken = captchaToken;
    }

    if (basketUtils.isPickup()) {
        params.promoBasket = 'PICKUP';
    }

    return ufeApi
        .makeRequest(url, {
            method: 'POST',
            body: JSON.stringify(params)
        })
        .then(data => (data.errorCode ? Promise.reject(data) : data));
}

module.exports = applyPromotion;
